import { useQuery } from "@tanstack/react-query";
import { StatCard } from "../StatCard";
import { LoadingSpinner } from "../LoadingSpinner";
import { ErrorState } from "../ErrorState";
import { getEventDashboardStats } from "../../services/enrolment.service";
import { getApiErrorMessage } from "../../lib/apiClient";

export function EventDashboardStatsPanel({ eventId }: { eventId: string }): JSX.Element {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["events", eventId, "dashboard"],
    queryFn: () => getEventDashboardStats(eventId),
  });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorState message={getApiErrorMessage(error)} />;
  if (!data) return <></>;

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatCard label="Total Students" value={data.totalStudents} />
      <StatCard label="Confirmed" value={data.confirmed} tone="green" />
      <StatCard label="Pending" value={data.pending} tone="yellow" />
      <StatCard label="Confirmation Rate" value={`${data.confirmationRate}%`} tone="blue" />
      <StatCard label="Declined" value={data.declined} tone="red" />
      <StatCard label="WhatsApp Sent" value={data.whatsappSent} />
      <StatCard label="WhatsApp Not Sent" value={data.whatsappNotSent} />
    </div>
  );
}
